export interface HubActionTypes {
  type: HubActions;
  payload?: any;
}

export enum HubActions {
  CREATE_HUB = "CREATE_HUB",
  GET_HUB_LIST = "GET_HUB_LIST",
  SET_HUB_LIST = "SET_HUB_LIST",
  SET_HUB_LIST_PAGE_COUNT = "SET_HUB_LIST_PAGE_COUNT",
  GET_HUB_DATA_BY_ID = "GET_HUB_DATA_BY_ID",
  SET_HUB_DATA_BY_ID = "SET_HUB_DATA_BY_ID",
  EDIT_HUB_DATA_BY_ID = "EDIT_HUB_DATA_BY_ID",
}
